export * from './lookup-table.repo';
